import { PortfolioItem } from '../../api';

import { GlobalScrollLock } from 'components/GlobalScrollLock';
import * as styled from '../styles/portfolio';

type Props = {
  items: PortfolioItem[];
  index: number;
  onClose: () => void;
  onPrev: () => void;
  onNext: () => void;
};

export const PortfolioLightbox = ({
  items,
  index,
  onClose,
  onPrev,
  onNext,
}: Props) => {
  const item = items[index];
  if (!item?.asset) return null;

  return (
    <styled.LightboxOverlay onClick={onClose}>
      <GlobalScrollLock />
      <styled.LightboxNav
        $side="left"
        onClick={(event) => {
          event.stopPropagation();
          onPrev();
        }}
        disabled={index === 0}
      >
        ‹
      </styled.LightboxNav>
      <styled.LightboxContent onClick={(event) => event.stopPropagation()}>
        {item.asset.kind === 'video' ? (
          <video src={item.asset.url} controls autoPlay />
        ) : (
          <img src={item.asset.url} alt="" />
        )}
        {item.caption && (
          <styled.LightboxCaption>{item.caption}</styled.LightboxCaption>
        )}
      </styled.LightboxContent>
      <styled.LightboxNav
        $side="right"
        onClick={(event) => {
          event.stopPropagation();
          onNext();
        }}
        disabled={index === items.length - 1}
      >
        ›
      </styled.LightboxNav>
      <styled.LightboxClose onClick={onClose}>✕</styled.LightboxClose>
    </styled.LightboxOverlay>
  );
};
